import { useQuery } from "react-query";
import { fetchProjectsWorkflows } from "../services/api";
import { Organization } from "../types";

export const useProjectsWorkflows = (organizationId: Organization["uid"]) =>
  useQuery([`projects-workflows-${organizationId}`, organizationId], () =>
    fetchProjectsWorkflows(organizationId)
  );
